import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { Link } from "react-router-dom";
import "./Navbar.css";
import { SidebarData } from "./Data";
//import { Auth, API, Storage } from "aws-amplify";
import { getCurrentUser } from 'aws-amplify/auth';
import { listUsuarios, listNotificaciones } from "../../graphql/queries";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import * as IoIcons from "react-icons/io";
import { GetNotificaciones, GetNotificacionesID, GetNotificacionesNuevas } from "../queries/Queries";
import { deleteNotificacionesNuevas, updateNotificaciones } from "../../graphql/mutations";
import { onCreateNotificaciones, onCreateNotificacionesNuevas } from "../../graphql/subscriptions";
import Notificaciones from "./Notificaciones";
import Moment, { updateLocale } from "moment";
import { generateClient } from "aws-amplify/api";
import { getUrl } from "@aws-amplify/storage"
const API = generateClient();

window.$name = ""; //global variable
const initialFormState = {
  username: "",
  formType: "principal",
};

function Navbarh() {
  const [sidebar, setSidebar] = useState(false);
  //const [userName, setUserName] = useState("");
  const [formState, updateFormState] = useState(initialFormState);
  const [url, setUrl] = useState("");
  const [mostrarNotificaciones, setMostrarNotificaciones] = useState(false);
  const [error, setError] = useState("");
  const [notificaciones, setNotificaciones] = useState([]);
  const [notificacionesSinFiltro, setNotificacionesSinFiltro] = useState([]);
  const [menu, setMenu] = useState([]);
  Moment.locale("en");
  const [usuarios, setUsuarios] = useState([
    {
      activo: window.$Activo,
      Almacen: window.$Almacen,
      AlmacenDInventario: window.$AlmacenDInventario,
      MarcarEmbarcadoAlmacen: window.$MarcarEmbarcadoAlmacen,
      MarcarFueradePlanta: window.$MarcarFueradePlanta,
      EmbarquesDInventario: window.$EmbarquesDInventario,
      MarcarEmbarcadoEmbarques: window.$MarcarEmbarcadoEmbarques,
      Cuarentena: window.$Cuarentena,
      Clientes: window.$Clientes,
      Cotizaciones: window.$Cotizaciones,
      Planeacion: window.$Planeacion,
      verPlaneacionBase: window.$verPlaneacionBase,
      ResumenOperacionVer: window.$ResumenOperacionVer,
      ResumenOperacionEDefectos: window.$ResumenOperacionEDefectos,
      ResumenOperacionEPLaboratorio: window.$ResumenOperacionEPLaboratorio,
      ResumenOperacionEAusentismoP: window.$ResumenOperacionEAusentismoP,
      ResumenOperacionEDatosExtra: window.$ResumenOperacionEDatosExtra,
      Calidad: window.$Calidad,
      Productos: window.$Productos,
      VerPrecioUnitario: window.$VerPrecioUnitario,
      Reciba: window.$Reciba,
      Usuarios: window.$Usuarios,
      image: window.$Imagen,
      PProduccion: window.$PProduccion,
      Producciones: window.$Producciones,
      Tickets: window.$Tickets,
      Facturacion: window.$Facturacion,
      Compras: window.$Compras,
      AgregarProvedores: window.$AgregarProvedores,
      AutorizarProvedores: window.$AutorizarProvedores,
      LevantarRequisicion: window.$LevantarRequisicion,
      AutorizarRequisicion: window.$AutorizarRequisicion,
      AutorizarCompra: window.$AutorizarCompra,
      Embarques: window.$Embarques,
      Ubicacion: window.$Ubicacion,
      GestionarUbicacion: window.$GestionarUbicacion,
      Notificaciones: window.$Notificaciones,
      Administrar: window.$Administrar,
      Metricas: window.$Metricas,
      ProduccionReporteSema: window.$ProduccionReporteSema,
      PProduccionAutNoFIFO1: window.$PProduccionAutNoFIFO1,
      PProduccionAutNoFIFO2: window.$PProduccionAutNoFIFO2,
      PlaneacionAutNoFIFO: window.$PlaneacionAutNoFIFO,
      verEmbarques: window.$verEmbarques,
      verPlaneacion: window.$verPlaneacion,
      verPlanProduccion: window.$verPlanProduccion,
      Autorizaciones: window.$Autorizaciones,
    },
  ]);
  window.$hora = new Date();
  const { formType } = formState;
  const MINUTE_MS = 60000;


  useEffect(() => {
    if (window.$refresh === true) {
      window.$refresh = false;
      window.location.reload(true);
    }
    checkUserdata();
    /*const interval = setInterval(async () => {
      await fetchNotificaciones(window.$name);
    }, 30000);
    return () => clearInterval(interval);*/
    //Cierra seción.

    const interval = setInterval(async () => {
      updateFormState(() => ({ ...formState, formType: "login" }));;
    }, 36000000);
    return () => clearInterval(interval);
  }, []);


  //Actualiza los datos de la notificación 
  async function actulizarnotificacion() {
    var mensaje = "";
    setMostrarNotificaciones(!mostrarNotificaciones);
    try {
      if (!mostrarNotificaciones === true) {
        await fetchNotificaciones(window.$name);
      } else {
        //Se obtiene la fecha menos un mes, para eliminar las notificaciones de más de un mes de antigüedad
        var now = new Date();
        now.setMonth(now.getMonth() - 1);
        const fechaUM = Moment(now).format("YYYY-MM-DD");
        //Se obtienen las notificaciones
        const apiData = await GetNotificacionesNuevas({
          or: [{ usuarioPara: { eq: window.$name } },
          { fecha: { le: fechaUM } }
          ]
        });

        //Se actualiza el campo de leído en las notificaciones en cuestión
        await Promise.all(
          apiData.map(async (mnotificacion, i) => {
            //Para eso se obtiene la notificación correspondiente
            const notific = await GetNotificacionesID(mnotificacion.NotificacionID);
            notific.Reg_Mod_Usuario = window.$name;
            notific.leido = true;
            delete notific.createdAt;
            delete notific.updatedAt;
            delete notific.__typename;
            // Se guardan los cambios en la notificación
            mensaje = "No se pudo actualizar la notificación principal; ";
            await API.graphql({ query: updateNotificaciones, variables: { input: notific } });
            //Se eliminan las notificaciones     

            mensaje = "No se pudo eliminar la notificación nueva; ";
            await API.graphql({ query: deleteNotificacionesNuevas, variables: { input: { id: mnotificacion.id, } } });
          })
        );
        //Se obtienen las nuevas notificaciones
        await fetchNotificaciones(window.$name);
      }
    } catch (err) {
      setError("Error. " + mensaje + err.errors[0].message);
    }
  }
  //Obtiene los datos de las notificaciones
  async function fetchNotificaciones(usuario) {

    var notificaciones = [];
    var notificacionAnterior = "";
    var contador = 1;

    //Se obtienen las notificaciones
    const apiData = await GetNotificacionesNuevas({ usuarioPara: { eq: usuario } });
    //Se agrupan las notificaciones
    const notificacionesOrdenadas = apiData.sort((a, b) =>
      a.Accion > b.Accion ? 1 : a.Accion < b.Accion ? -1 : 0);
    setNotificacionesSinFiltro(notificacionesOrdenadas);

    await Promise.all(
      notificacionesOrdenadas.map(async (mnotificacion, i) => {
        //Si es el primer registro, se asigna valor a notificacionAnterior
        if (i === 0) notificacionAnterior = mnotificacion.Accion;
        //Se revisa si la notificación actual es diferente a la notificacion anterior
        if (notificacionAnterior != mnotificacion.Accion) {
          contador = contador - 1;
          const mensaje = notificacionesOrdenadas[i - 1];
          if (contador === 1) {
            mensaje.mensaje = mensaje.notificacion;
          } else {
            mensaje.mensaje = contador + " " + mensaje.Accion;
          }
          notificaciones.push(mensaje);
          notificacionAnterior = mnotificacion.Accion;
          contador = 1;
        }
        //Se revisa si es el último registro
        if (i === notificacionesOrdenadas.length - 1) {
          const mensaje = mnotificacion;
          if (contador === 1) {
            mensaje.mensaje = mensaje.notificacion;
          } else {
            mensaje.mensaje = contador + " " + mensaje.Accion;
          }
          notificaciones.push(mensaje);
        }
        //Se aumenta en uno el contador
        contador++;
        return mnotificacion;
      })
    );

    //Se retornan los datos de notificaciones
    setNotificaciones(notificaciones);
    return notificaciones;
  }
  //Obtiene los datos de los usuarios
  async function fetchUsuarios(pusuario) {
    var nextToken = null;
    var apiData = [];
    do {
      const apiOData = await API.graphql({
        query: listUsuarios,
        variables: { filter: { activo: { eq: true } }, limit: 100000000, nextToken },
      });
      const odatos = await apiOData.data.listUsuarios.items;
      nextToken = await apiOData.data.listUsuarios.nextToken;
      apiData = await [...apiData, ...odatos];
    } while (nextToken != null);
    //const apiData = await API.graphql({ query: listUsuarios, variables: { limit: 100000000 } });
    const usuariosFromAPI = apiData.filter(
      (usuario) => usuario.usuario.toUpperCase() === pusuario
    );
    await Promise.all(
      usuariosFromAPI.map(async (usuario) => {
        if (usuario.image) {
          const image = await getUrl({ key: usuario.image });
          usuario.imagename = usuario.image;
          usuario.image = image.url.toString();
          window.$Imagen = image.url.toString();
        }
        //Se revisa si se tienen permisos para obtener las notificaciones
        if (usuario.Notificaciones) {
          await fetchNotificaciones(pusuario);
        }
        if (
          usuario.TicketsSoporte ||
          usuario.TicketsUsuarios ||
          usuario.TicketsAuditor
        )
          usuario.Tickets = true;
        else usuario.Tickets = false;

        if (
          usuario.PProduccion === true ||
          usuario.Produccion === true ||
          usuario.ProduccionInspeccion === true
        )
          usuario.Producciones = true;
        else usuario.Producciones = false;

        if (
          usuario.Cuarentena === true ||
          usuario.Incoming === true ||
          usuario.ProduccionCalidad ||
          usuario.ProduccionRecuperacion
        )
          usuario.Calidad = true;
        else usuario.Calidad = false;

        if (
          usuario.PProduccionAutNoFIFO1 === true ||
          usuario.PProduccionAutNoFIFO2 === true ||
          usuario.PlaneacionAutNoFIFO === true ||
          usuario.AutorizarCalidad === true ||
          usuario.AutorizarEmbarques === true ||
          usuario.AutorizarTodo === true
        )
          usuario.Autorizaciones = true;
        else usuario.Autorizaciones = false;

        window.$Activo = usuario.activo;
        window.$Almacen = usuario.Almacen;
        window.$Clientes = usuario.Clientes;
        window.$Cuarentena = usuario.Cuarentena;
        window.$AlmacenDInventario = usuario.AlmacenDInventario;
        window.$MarcarEmbarcadoAlmacen = usuario.MarcarEmbarcadoAlmacen;
        window.$MarcarFueradePlanta = usuario.MarcarFueradePlanta;
        window.$EmbarquesDInventario = usuario.EmbarquesDInventario;
        window.$MarcarEmbarcadoEmbarques = usuario.MarcarEmbarcadoEmbarques;
        window.$Calidad = usuario.Calidad;
        window.$Incoming = usuario.Incoming;
        window.$Cotizaciones = usuario.Cotizaciones;
        window.$Planeacion = usuario.Planeacion;
        window.$verPlaneacionBase = usuario.verPlaneacionBase;
        window.$ResumenOperacionVer = usuario.ResumenOperacionVer;
        window.$ResumenOperacionEDefectos = usuario.ResumenOperacionEDefectos;
        window.$ResumenOperacionEPLaboratorio = usuario.ResumenOperacionEPLaboratorio;
        window.$ResumenOperacionEAusentismoP = usuario.ResumenOperacionEAusentismoP;
        window.$ResumenOperacionEDatosExtra = usuario.ResumenOperacionEDatosExtra;
        window.$Productos = usuario.Productos;
        window.$VerPrecioUnitario = usuario.VerPrecioUnitario;
        window.$Reciba = usuario.Reciba;
        window.$RecibaDescargar = usuario.RecibaDescargar;
        window.$IncomingDescarga = usuario.IncomingDescarga;
        window.$Usuarios = usuario.Usuarios;
        window.$Producciones = usuario.Producciones;
        window.$PProduccion = usuario.PProduccion;
        window.$Embarques = usuario.Embarques;
        window.$Facturacion = usuario.Facturacion;
        window.$Compras = usuario.Compras;
        window.$AgregarProvedores = usuario.AgregarProvedores;
        window.$AutorizarProvedores = usuario.AutorizarProvedores;
        window.$LevantarRequisicion = usuario.LevantarRequisicion;
        window.$AutorizarRequisicion = usuario.AutorizarRequisicion;
        window.$AutorizarCompra = usuario.AutorizarCompra;
        window.$Administrar = usuario.Administrar;
        window.$Metricas = usuario.Metricas;
        window.$Ubicacion = usuario.Ubicacion;
        window.$GestionarUbicacion = usuario.GestionarUbicacion;
        window.$Notificaciones = usuario.Notificaciones;
        window.$Produccion = usuario.Produccion;
        window.$ProduccionInspeccion = usuario.ProduccionInspeccion;
        window.$ProduccionCargaManual = usuario.ProduccionCargaManual;
        window.$ProduccionCalidad = usuario.ProduccionCalidad;
        window.$ProduccionRecuperacion = usuario.ProduccionRecuperacion;
        window.$Tickets = usuario.Tickets;
        window.$TicketsUsuarios = usuario.TicketsUsuarios;
        window.$TicketsSoporte = usuario.TicketsSoporte;
        window.$TicketsAuditor = usuario.TicketsAuditor;
        window.$ProduccionReporteSema = usuario.ProduccionReporteSema;
        window.$PProduccionAutNoFIFO1 = usuario.PProduccionAutNoFIFO1;
        window.$PProduccionAutNoFIFO2 = usuario.PProduccionAutNoFIFO2;
        window.$PlaneacionAutNoFIFO = usuario.PlaneacionAutNoFIFO;
        window.$verEmbarques = usuario.verEmbarques;
        window.$verPlaneacion = usuario.verPlaneacion;
        window.$verPlanProduccion = usuario.verPlanProduccion;
        window.$Autorizaciones = usuario.Autorizaciones;
        window.$Datos = true;
        return usuario;
      })
    );
    if (!usuariosFromAPI.length) {
      window.$name = "";
      updateFormState(() => ({ ...formState, formType: "login" }));
    } else setUsuarios(usuariosFromAPI);
  }

  async function checkUserdata() {
    try {
      const user = await getCurrentUser(); //Auth.currentAuthenticatedUser();
      //setUserName(user.username);

      window.$name = user.username.toUpperCase();
      /*if (!window.$Datos) {*/
      //Función que crea las subscripciones
      //se suscriben para los cambios en planeación base
      const variables = {
        filter: {
          // filtro en base a la fecha de planeación.
          usuarioPara: { eq: user.username.toUpperCase() }
        }
      };

      //Subscripciones de la planeación base
      API.graphql({ query: onCreateNotificacionesNuevas, variables }).subscribe({
        next: ({ provider, value }) => fetchNotificaciones(user.username.toUpperCase()), //value.data.onUpdatePlaneacionBase
        error: (error) => console.warn(error)
      });

      await fetchUsuarios(user.username.toUpperCase());
      /* } else if (window.$Notificaciones) {
         await fetchNotificaciones(user.username.toUpperCase());
       }*/
      const menuData = await SidebarData(user.username.toUpperCase());
      setMenu(menuData);

      if (window.location.href.lastIndexOf("home") !== -1) setUrl("Bienvenido");

      if (window.location.href.lastIndexOf("cotizaciones") !== -1)
        if (window.$Cotizaciones === true) setUrl("Cotizaciones");
        else goHome();

      if (window.location.href.lastIndexOf("calidad") !== -1)
        if (window.$Calidad === true) setUrl("Calidad");
        else goHome();

      if (window.location.href.lastIndexOf("clientes") !== -1)
        if (window.$Clientes === true) setUrl("Clientes");
        else goHome();

      if (window.location.href.lastIndexOf("productos") !== -1)
        if (window.$Productos === true) setUrl("Productos");
        else goHome();
      if (window.location.href.lastIndexOf("almacen") !== -1)
        if (window.$Almacen === true) setUrl("Almacén");
        else goHome();
      if (window.location.href.lastIndexOf("reciba") !== -1)
        if (window.$Reciba === true) setUrl("Reciba");
        else goHome();
      if (window.location.href.lastIndexOf("planeacion") !== -1)
        if (window.$Planeacion === true || window.$verPlaneacion === true)
          setUrl("Planeación");
        else goHome();
      if (window.location.href.lastIndexOf("planeacionb") !== -1)
        if (window.$verPlaneacionBase === true)
          setUrl("Planeación base");
        else goHome();
      if (window.location.href.lastIndexOf("pproduccion") !== -1)
        if (window.$Producciones === true || window.$verPlanProduccion === true)
          setUrl("Produccion");
        else goHome();
      if (window.location.href.lastIndexOf("embarques") !== -1)
        if (window.$Embarques === true || window.$verEmbarques === true)
          setUrl("Embarques");
        else goHome();
      if (window.location.href.lastIndexOf("administrar") !== -1)
        if (window.$Administrar === true) setUrl("Administrar");
        else goHome();
      if (window.location.href.lastIndexOf("metricas") !== -1)
        if (window.$Metricas === true) setUrl("Métricas");
        else goHome();
      if (window.location.href.lastIndexOf("facturacion") !== -1)
        if (window.$Facturacion === true) setUrl("Facturación");
        else goHome();
      if (window.location.href.lastIndexOf("compras") !== -1)
        if (window.$Compras === true) setUrl("Compras");
        else goHome();
      if (window.location.href.lastIndexOf("ubicacion") !== -1)
        if (window.$Ubicacion === true) setUrl("Ubicación del material");
        else goHome();
      if (window.location.href.lastIndexOf("tickets") !== -1)
        if (window.$Tickets === true) setUrl("Atención a usuarios");
        else goHome();
      if (window.location.href.lastIndexOf("usuarios") !== -1)
        if (window.$Usuarios === true) setUrl("Usuarios");
        else goHome();
    } catch (err) {
      //setUserName("");
      window.$name = "";
      updateFormState(() => ({ ...formState, formType: "login" }));
    }
  }

  function goHome() {
    if (window.location.href.lastIndexOf("home") === -1)
      updateFormState(() => ({ ...formState, formType: "home" }));
  }
  const showSidebar = () => setSidebar(!sidebar);
  return (
    <>
      {(!window.$refresh) && (<>
        {formType === "principal" && window.$name && (
          <>
            <div className="navbar fcolord6e2e9">
              <img
                className="imgmarl"
                src="assets/img/Logo/logosf.png"
                onClick={goHome}
              />
              <Link to="#" className="menu-bars">
                {sidebar ? (
                  <AiIcons.AiOutlineClose onClick={showSidebar} />
                ) : (
                  <FaIcons.FaBars onClick={showSidebar} />
                )}
              </Link>
              <div className="htexto">
                <h3 className="tbold">BTI CLOUD { }</h3>
                <h5>{url}</h5>
              </div>

              <div
                className={
                  window.$Notificaciones ? "notifi " : "notifi displaynone"
                }
                onClick={actulizarnotificacion}
              >
                <IoIcons.IoIosNotificationsOutline className="fontsize30px" />
                {notificacionesSinFiltro.length > 0 && (
                  <div className="contador">{notificacionesSinFiltro.length}</div>
                )}
              </div>

              <div className="davatar">
                <div>
                  {window.$Imagen ? (
                    <img className="avatari" src={window.$Imagen} width="100px" alt={JSON.stringify(window.$Imagen)} />
                  ) : (
                    <img className="avatar" src="assets/img/Avatar/sesion.png" />
                  )}
                  <label className="tavatar">{window.$name}</label>
                </div>
              </div>
              {mostrarNotificaciones && notificaciones.length > 0 && (
                <div className="notificaciones">
                  {notificaciones.map((notificacion) => (
                    <span className="notificacion">
                      {notificacion.mensaje}
                      <FaIcons.FaCheckDouble
                        className="ml-2 colorAzul"
                      />
                    </span>
                  ))}
                  < Notificaciones
                    usuario={window.$name}
                    valorDeREtorno={actulizarnotificacion}
                  />
                </div>
              )}
              {mostrarNotificaciones && notificaciones.length <= 0 && (
                <div className="notificaciones">
                  <span className="notificacion">
                    Sin notificaciones
                  </span>
                  < Notificaciones
                    usuario={window.$name}
                    valorDeREtorno={actulizarnotificacion}
                  />
                </div>
              )}
              {error}
              {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(notificacionesSinFiltro)}</div>*/}
            </div>
            <nav className={sidebar ? "nav-menu active " : "nav-menu"}>
              <ul className="nav-menu-items " onClick={showSidebar}>
                <li className="navbar-toggle">
                  <Link to="#" className="hmenu">
                    <span className="ml16">Menú</span>
                  </Link>
                </li>
                {menu.map((item, index) => {
                  if (item.mostrar === true) {
                    return (
                      <li key={index} className={item.cName}>
                        <Link to={item.path}>
                          {item.icon}
                          <span className="ml16">{item.title}</span>
                        </Link>
                      </li>
                    );
                  }
                })}
              </ul>
            </nav>
          </>
        )}
        {formType === "login" && <Redirect to="/login" />}
        {formType === "home" && <Redirect to="/home" />}
      </>)}
    </>
  );
}

export default Navbarh;
